import { getAddressBook } from 'api/v1/addressBook'
import ModalLink from 'components/ModalLink'
import i18n from 'i18n'
import { memo, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useModal } from 'store/app/hooks'
import {
  updateAddressBookList,
  updateAmount,
  updateIsAddOrEditAddressBook,
  updateIsFocus,
  updateIsUseAddressBook,
  updateLayerNum,
  updateSelectedToken,
  updateShowAddAddress,
  updateShowAddressBookList,
  updateTitleName,
  updateWidthAddress,
} from 'store/withdraw/actions'
import {
  useAddressBookList,
  useIsAddOrEditAddressBook,
  useTitleName,
  useWithdrawAddress,
  useWithdrawLayoutType,
} from 'store/withdraw/hook'
import { WithdrawLayoutType } from 'store/withdraw/types'
import { ContentWrap } from 'styles'
import { WithdrawLayoutSelection } from 'views/Withdraw/WithdrawLayoutSelection'
import { Equal } from '../../utils/equal'
import AddressBook from './addOrEditAddressBook'
import WithdrawMain from './WithdrawMain'
import { updateModal } from '../../store/app/actions/modalActions'
import { useWeb3Address } from '../../store/web3/hooks'
import { isValidAddress } from '../../utils/address'

const Withdraw = memo(() => {
  const dispatch = useDispatch()
  const modal = useModal('withdraw')
  const myAddress = useWeb3Address()
  const layoutType = useWithdrawLayoutType()
  const titleName = useTitleName()
  const addressBookList = useAddressBookList()
  const isAddOrEditAddressBook = useIsAddOrEditAddressBook()
  const address = useWithdrawAddress()

  // Reset the layout when the modal is closed
  useEffect(() => {
    return () => {
      dispatch(updateLayerNum(WithdrawLayoutType.None))
    }
  }, [dispatch])

  useEffect(() => {
    if (layoutType === WithdrawLayoutType.Withdraw) {
      dispatch(updateWidthAddress(myAddress))

      dispatch(updateIsFocus(false))
    }

    if (layoutType === WithdrawLayoutType.Transfer) {
      dispatch(updateWidthAddress(''))

      dispatch(updateIsFocus(true))
      dispatch(updateIsUseAddressBook(false))
    }
  }, [dispatch, myAddress, layoutType])
  useEffect(() => {
    if (
      !address ||
      !isValidAddress(address) ||
      Equal.address(address, myAddress)
    ) {
      dispatch(updateShowAddAddress(false))
      return
    }
    const flag = addressBookList.find((item) =>
      Equal.address(item.address, address),
    )
    if (flag) {
      dispatch(updateShowAddAddress(false))
    } else {
      dispatch(updateShowAddAddress(true))
    }
  }, [dispatch, address, myAddress, addressBookList])
  const fetchAddressBookList = useCallback(() => {
    try {
      getAddressBook(1).then((res) => {
        if (Array.isArray(res?.data)) {
          dispatch(
            updateAddressBookList(
              res?.data?.sort((a, b) => {
                return a.type - b.type
              }),
            ),
          )
        }
      })
    } catch (error) {}
  }, [dispatch])

  return (
    <ModalLink
      isIn={modal}
      width={'435px'}
      header={titleName}
      onClose={() => {
        dispatch(updateModal({ modal: 'withdraw', open: false }))
        dispatch(updateShowAddressBookList(false))
        dispatch(updateLayerNum(WithdrawLayoutType.None))
        dispatch(updateSelectedToken(undefined))
        dispatch(updateAmount(''))

        dispatch(
          updateTitleName(
            i18n.t('balances-withdraw', { defaultValue: 'Withdraw' }),
          ),
        )
      }}
      maskClose={false}
      onHeaderClick={
        layoutType === WithdrawLayoutType.None
          ? undefined
          : () => {
              dispatch(updateLayerNum(WithdrawLayoutType.None))

              dispatch(updateSelectedToken(undefined))

              dispatch(updateIsAddOrEditAddressBook(undefined))

              dispatch(
                updateTitleName(
                  i18n.t('balances-withdraw', { defaultValue: 'Withdraw' }),
                ),
              )
              dispatch(updateShowAddressBookList(false))
            }
      }
    >
      <ContentWrap>
        {layoutType === WithdrawLayoutType.None ? (
          <WithdrawLayoutSelection isWithdraw={true} />
        ) : isAddOrEditAddressBook === undefined ? (
          <WithdrawMain
            fetchAddressBookList={fetchAddressBookList}
            myAddress={myAddress}
          />
        ) : (
          <AddressBook fetchAddressBookList={fetchAddressBookList} />
        )}
      </ContentWrap>
    </ModalLink>
  )
})

export default Withdraw
